module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/26_9a6fec9b3718d8c258854dad0cdc6f1f.jpg";